// @flow

import { ReduxAsyncAction } from '../support/utils';
import dash_api from '../support/dash_api';
import NotificationActions from './NotificationActions';

const APPLE_ROUTE = '/v1/apple-search-ads';
const HAS_CREDENTIAL_MAP = {
  asa_certificate: 'isCertificateSaved',
  asa_key: 'isKeySaved'
};

const SaveASACredential = new ReduxAsyncAction('APPLE_UPLOAD_CREDENTIAL');
SaveASACredential.registerRequest((key, value) => {
  return dash_api
    .post(`${APPLE_ROUTE}/save-credential`, { key, value })
    .then(() => ({ [HAS_CREDENTIAL_MAP[key]]: true }));
});

export const UPLOAD_CREDENTIAL = SaveASACredential.constants;
export const saveASACredential = SaveASACredential.request;

const GetOrganizations = new ReduxAsyncAction('APPLE_GET_ORGANIZATIONS');
GetOrganizations.registerRequest(() => {
  return dash_api
    .get(`${APPLE_ROUTE}/organizations`)
    .then(res => ({ organizations: res.data }));
});

export const GET_ORGANIZATIONS = GetOrganizations.constants;
export const getOrganizations = GetOrganizations.request;

const SaveASAConfig = new ReduxAsyncAction('APPLE_SAVE_CONFIG');
SaveASAConfig.registerRequest(configToSave => {
  return dash_api
    .post(`${APPLE_ROUTE}/save-config`, { configToSave })
    .then(({ data }) => {
      data.neverConfigured = false;

      NotificationActions.showNotification(
        `Apple has been saved and enabled`,
        'success'
      );

      return data;
    });
});

export const APPLE_SAVE_CONFIG = SaveASAConfig.constants;
export const saveASAConfig = SaveASAConfig.request;

const ResetASASettings = new ReduxAsyncAction('APPLE_RESET_SETTINGS');
ResetASASettings.registerRequest(() => {
  return dash_api.get(`${APPLE_ROUTE}/reset-credentials`);
});

export const RESET_SETTINGS = ResetASASettings.constants;
export const resetASASettings = ResetASASettings.request;
